import type { PropTypes } from './FavoriteItem.types';
import type { ReactElement } from 'react';

import { Card, Flex, Skeleton, Text } from '@rango-dev/whale';
import React from 'react';

import { Image } from '../../common/Image';

import styles from './FavoriteItem.module.css';

export function FavoriteItem(props: PropTypes): ReactElement {
  const { logo, name, title, loading } = props;

  return (
    <Card size="1" variant="ghost">
      <Flex justify="between" align="center">
        <Text size="3" color="gray">
          {title}
        </Text>
        <Flex align="center" gap="1">
          {loading ? (
            <Skeleton width="52px" height="20px" />
          ) : (
            <>
              {logo && (
                <Image src={logo} width={24} height={24} alt={name ?? ''} className={styles.logo} />
              )}
              <Text size="3" weight="bold">
                {name ?? '-'}
              </Text>
            </>
          )}
        </Flex>
      </Flex>
    </Card>
  );
}
